module.exports = __webpack_public_path__ + "img/review4.126c836d.jpeg";